// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ka-7";
export var emphasizeQuantity = "_ka-3";
export var flatBottomCorners = "_ka-5";
export var productImage = "_ka-0";
export var quantityContainer = "_ka-2";
export var quantityHeader = "_ka-6";
export var tooltip = "_ka-1";
export var wrapAndEllipsesOverflow = "_ka-4";